/* eslint-disable no-empty-function */
'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
    paymentMethodData: null,
    appleWebComponent: null,
    applepayIsAvailable: function (paymentMethodResponse, config, paymentMethod) {
        return this.init(
            paymentMethodResponse,
            null,
            paymentMethod,
            config,
            {shippingContact: {}, billingContact: {}},
            () => {},
            () => {},
            true
        );
    },
    init: function (
        paymentMethodResponse,
        container,
        selectedPaymentMethod,
        config,
        userDataFromStore,
        onValidateMerchantCallback,
        onAuthorizedCallback,
        checkIfApplepayIsAvailable
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        if (this.appleWebComponent) {
            this.appleWebComponent.unmount();
        }

        const checkout = new AdyenCheckout(configuration);
        const merchantIdEnvironment =
            config.environment == 'prod' || config.environment == 'live' ? 'prod' : 'development';

        const $that = this;
        this.appleWebComponent = checkout.create('applepay', {
            amount: {
                currency: config.priceCurrency,
                value: config.priceAmount
            },
            countryCode: config.countryCode,
            configuration: {
                merchantName: 'Rituals Cosmetics',
                merchantId: config.merchantId + merchantIdEnvironment,
                billingContact: userDataFromStore.billingContact,
                shippingContact: userDataFromStore.shippingContact
            },
            buttonType: 'plain',
            buttonColor: 'black',
            onValidateMerchant: onValidateMerchantCallback,
            onSubmit: (state) => {
                if (!state.isValid) {
                    $that.paymentMethodData = null;
                    return;
                }
                $that.paymentMethodData = state.data.paymentMethod;
            },
            onAuthorized: onAuthorizedCallback
        });

        if (checkIfApplepayIsAvailable) {
            return this.appleWebComponent
                .isAvailable()
                .then(() => true)
                .catch(() => false);
        }

        this.appleWebComponent
            .isAvailable()
            .then(() => {
                this.appleWebComponent.mount(container);
            })
            .catch((e) => {
                console.error('Apple pay not available', e);
            });
    }
};

module.exports = exportFunctions;
